module.exports = __webpack_public_path__ + "img/logo2.9f01cd87.png";